const Input = {
  baseStyle: ({ theme }: any) => ({
    border: theme.preon.borders.input,
    borderRadius: "input",
    color: "white",
    bg: "transparent"
  }),
  sizes: {
    xs: {
      height: "inputlike.xs"
    },
    sm: {
      height: "inputlike.sm"
    },
    md: {
      height: "inputlike.md"
    },
    lg: {
      height: "inputlike.lg"
    }
  }
};

export default Input;
